import Box, { type BoxProps } from "@mui/material/Box";
import * as React from "react";

interface TabPanelProps extends Omit<BoxProps, "children"> {
  children?: React.ReactNode;
  index: number | string;
  value: number | string;
  uniqueKey: string;
  renderOnClick?: boolean;
}

function TabPanel(props: TabPanelProps) {
  const {
    children,
    value,
    index,
    uniqueKey,
    renderOnClick = false,
    sx,
    ...other
  } = props;
  const uniqueId = `${uniqueKey}-tabpanel-${index}`;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={uniqueId}
      aria-labelledby={uniqueId}
      {...other}
      sx={[
        {
          height: "100%",
          overflow: "hidden",
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {renderOnClick
        ? value === index && <Box sx={{ p: 0 }}>{children}</Box>
        : children}
    </Box>
  );
}

export default TabPanel;
